import { useMediaQuery } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { getLoginStatus } from "../config/config";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { stateType } from "../store/store.type";

// Custom Hook to manage top level code of <AppLayout/> component
const useAppLayout = () => {
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const isMediumScreen = useMediaQuery("(max-width:1200px)");
  const sidePanelOpen = useSelector(
    (sel: stateType) => sel.panelSlice.panelOpen,
  );
  const isLogedin: boolean = getLoginStatus();
  const [activityWindowOpened, setActivityWindowOpened] = useState(true);
  const location = useLocation();

  const { userType } = useSelector(
    (sel: stateType) => sel.userProfileSlice.data,
  );

  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/summary");
    }
    if (!isLogedin) {
      navigate("/login");
    }
  }, []);
  useEffect(() => {
    if (location.pathname === "/summary") {
      setActivityWindowOpened(true);
    } else {
      setActivityWindowOpened(false);
    }
  }, [location.pathname]);

  return {
    isSmallScreen,
    sidePanelOpen,
    isMediumScreen,
    isLogedin,
    activityWindowOpened,
    userType,
  };
};

export default useAppLayout;
